import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import { Fragment } from 'react';
import {
  eventPaces,
  eventDistances,
  eventTerrains,
  eventRegroups,
  eventWeatherCancellations,
} from '../../utils/events';
import type { Event } from '../../types/Event';

type Props = {
  event: Event;
};

const RideDetailsTable = ({ event }: Props) => {
  const { pace, distance, terrain, regroup, weatherCancellation, loop } = event;

  if (!pace && !distance && !terrain && !regroup && !weatherCancellation && !loop) {
    return null;
  }

  const rows: { label: string; value: React.ReactNode }[] = [];

  if (pace) {
    rows.push({
      label: 'Pace',
      value: `${eventPaces[pace].name} (${eventPaces[pace].description})`,
    });
  }

  if (distance) {
    rows.push({
      label: 'Distance',
      value: eventDistances[distance].name,
    });
  }

  if (terrain) {
    rows.push({
      label: 'Terrain',
      value: (
        <Tooltip title={eventTerrains[terrain].description}>
          <span>{eventTerrains[terrain].name}</span>
        </Tooltip>
      ),
    });
  }

  if (regroup) {
    rows.push({
      label: 'Regroup',
      value: eventRegroups[regroup].name,
    });
  }

  if (weatherCancellation) {
    rows.push({
      label: 'Weather',
      value: eventWeatherCancellations[weatherCancellation].name,
    });
  }

  if (loop) {
    rows.push({
      label: 'Route',
      value: 'Loop',
    });
  }

  return (
    <Fragment>
      <Typography variant="h3" sx={{ mt: 3 }}>Ride Details</Typography>
      <Box
        component="table"
        sx={{
          mb: 2,
          borderCollapse: 'collapse',
          '& td': {
            py: 0.5,
            pr: 2,
            verticalAlign: 'top',
          },
          '& td:first-of-type': {
            color: 'text.secondary',
            whiteSpace: 'nowrap',
          },
        }}
      >
        <tbody>
          {rows.map((row) => (
            <tr key={row.label}>
              <td>{row.label}</td>
              <td>{row.value}</td>
            </tr>
          ))}
        </tbody>
      </Box>
    </Fragment>
  );
};

export default RideDetailsTable;
